import React from 'react'
import Sitenav from './Sitenav';



const Leftbar = () => {
   return (
      <Sitenav />
   )
}

export default Leftbar